import ListingInvitationRowContainer from './listing_invitation_row_container';

const ListingInvitationRow = ListingInvitationRowContainer;
export default ListingInvitationRow;
